<div id="content" class="allcp-form" ng-controller="CustomerExpenseController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav nav-tabs navbar-left">
            <li class="active">
                <a href="#" class="btn btn-operation ml10" ng-click="setDate('week')">
                    Weekly
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-operation ml10" ng-click="setDate('month')">
                    Monthly
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-operation ml10" ng-click="setDate('quarter')">
                    Quarterly
                </a>
            </li>
            <li>
                <a href="#" class="btn btn-operation ml10" ng-click="setDate('year')">
                    Yearly
                </a>
            </li>
        </ul>
        <div class="nav navbar-nav nav-tabs navbar-center"></div>
        <div class="nav navbar-nav nav-tabs navbar-right">
            <div class="form-group floating ml10">
                <input type="text" options="opts" date-range-picker class="btn btn-operation text-input form-control " ng-model="filterData.created_at" placeholder="Date Filter">
                <label>Date Filter</label>
                <i class="icon-calendar"></i>
            </div>
    </header>
    <div class="panel-body">
        <div class="row">
            <div class="billing-card-container" ng-repeat="item in data.counts" ng-class="{  'selected-row' :selectedItems.indexOf(item.$$hashKey) !== -1 }">
                <div class="billing-card">
                    <div class="billing-card-header">
                        <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                            <input type="checkbox" ng-click="checkBilling(item)" ng-checked="selectedItems.indexOf(item.$$hashKey) !== -1" id="checkboxDefault-{{item.id}}">
                            <span class="checkbox mn"></span>
                        </label>
                    </div>
                    <div class="billing-card-body">
                        <div class="billing-date">
                            <h4>Date</h4>
                            <p>{{ item.start }} - {{ item.end }}</p>
                        </div>
                        <div class="qty-total-container">
                            <div class="qty">
                                <h4>Qty</h4>
                                <p>{{ item.count }}</p>
                            </div>
                            <div class="total">
                                <h4>Total</h4>
                                <p>${{ item.total }}</p>
                            </div>
                        </div>
                        <a href="#" ng-click="printInvoice(item)" class="btn btn-block btn-outline">View Invoice</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="panel-body" ng-if="data.orders">
        <h3>Orders</h3>
        <div ng-include="'modules/customer/partials/orders.html'"></div>
    </div>
    
    <div class="navbar fixed-panel-footer" ng-if="selectedItems.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAllBilling(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAllBilling(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#" ng-click="printInvoiceAll()" class="btn btn-outline">Print {{ selectedItems.length }} Invoice</a>
        </div>
    </div>
</div>
